module.exports = __webpack_public_path__ + "img/744.45a2fb4a.jpg";